// import {
//   SiC, SiPython, SiDart, SiJavascript,
//   SiFlutter, SiReact, SiExpo, SiHtml5, SiCss,
//   SiNodedotjs, SiFlask, SiMysql, SiSqlite, SiMongodb,
//   SiFirebase, SiDocker, SiPostman, SiGit, SiGithub,
//   SiSupabase, SiBlender, SiDotnet
// } from "react-icons/si";
// import { TbBrandCSharp, TbSql } from "react-icons/tb";
// import { TbApi } from "react-icons/tb";
// import { FaJava } from "react-icons/fa";

export const skillsData = {
  languages: ["C#","JAVA", "PYTHON", "DART"],
  mobile: ["FLUTTER", "REACT NATIVE", "Expo Go"],
  frontend: ["REACT", "HTML5", "CSS3", "JAVASCRİPT"],
  backend: ["NODE.JS (Express.js)", "Python(flask)"],
  database: ["MSSQL", "MongoDB", "FIREBASE (Firestore)"],
  devops_tools: ["DOCKER", "POSTMAN", "FIREBASE (Auth)", "Git", "Github", "Supabase"],
  design_3DModeling: ["BLENDER"],
  networking: ["CISCO", "CISCO PACKET TRACER", "WIRESHARK"] 
};

export const category_names = {
  languages: "LANGUAGES",
  mobile: "MOBİLE",
  frontend: "FRONTEND",
  backend: "BACKEND",
  database: "DATABASE",
  devops_tools: "DEVOPS & TOOLS",
  design_3DModeling: "DESİGN & 3D MODELİNG",
    networking: "NETWORKING"

}

export const skillIcons = {
  // Languages
  "C#": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/csharp/csharp-original.svg"
      alt="C#"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "JAVA": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg"
      alt="Java"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "PYTHON": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg"
      alt="Python"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "DART": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dart/dart-original.svg"
      alt="Dart"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),

  // Mobil
  "FLUTTER": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg"
      alt="Flutter"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "REACT NATIVE": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
      alt="React Native"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "Expo Go": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/expo/expo-original.svg"
      alt="Expo Go"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),

  // Frontend Web
  "REACT": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
      alt="React"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "HTML5": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg"
      alt="HTML5"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "CSS3": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg"
      alt="CSS3"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "JAVASCRİPT": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
      alt="JavaScript"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),

  // Backend
  "NODE.JS (Express.js)": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg"
      alt="Node.js"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "Python(flask)": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg"
      alt="Flask"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),

  // Databases
  "MSSQL": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/microsoftsqlserver/microsoftsqlserver-original.svg"
      alt="MSSQL"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "MongoDB": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg"
      alt="MongoDB"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "FIREBASE (Firestore)": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-original.svg"
      alt="Firebase"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),

  // DevOps & Tools
  "DOCKER": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg"
      alt="Docker"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "POSTMAN": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postman/postman-original.svg"
      alt="Postman"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "FIREBASE (Auth)": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-original.svg"
      alt="Firebase"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "Git": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg"
      alt="Git"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "Github": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg"
      alt="GitHub"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "Supabase": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/supabase/supabase-original.svg"
      alt="Supabase"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "BLENDER": (
    <img
      src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/blender/blender-original.svg"
      alt="Blender"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />    
  ),
  "WIRESHARK": (
    <img
      src="/image/wiresharka.png"
      alt="Wireshark"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "CISCO": (
    <img
      src="https://cdn.worldvectorlogo.com/logos/cisco-2.svg"
      alt="Cisco"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  ),
  "CISCO PACKET TRACER": (
    <img
      src="/image/cisc.webp"
      alt="Cisco Packet Tracer"
      width="50"
      height="50"
      style={{ borderRadius: 8, margin: 5, display: "inline-block", verticalAlign: "middle" }}
    />
  )
};
export const translations = {
  tr: {
    role: "Bilgisayar Mühendisi",
    aboutTitle: "Hakkımda",
    aboutText: "Konya Teknik Üniversitesi Bilgisayar Mühendisliği bölümü mezunuyum. Mobil uygulamalardan karmaşık backend sistemleri ve bilgisayar ağlarına kadar uzanan geniş bir yelpazede, modern teknolojileri kullanarak ölçeklenebilir ve kullanıcı dostu çözümler geliştiriyorum.",
    skillsTitle: "Yetenekler",
    projectsTitle: "Projelerim",
    navAbout: "Hakkımda",
    navProjects: "Projeler",
    navContact: "İletişim",
    contact: "İletişim",
    contactTitle: "Bana Ulaşın",
    filterAll: "Hepsi",
    filterMobile: "Mobil",
    filterWeb: "Web",
    filterAi: "Yapay Zeka",
    filterDesign: "Tasarım",
    formName: "Adınız",
    formEmail: "E-posta Adresiniz",
    formMsg: "Mesajınız",
    formBtn: "Gönder",
    navCv: "CV İndir",
    projects: [
      {
        title: "Bitki Hastalıkları Tespit Uygulaması (Lisans Bitirme Projesi)",
        category: ["mobile", "ai"],
        desc: "Konya Teknik Üniversitesi Bilgisayar Mühendisliği akademik lisans bitirme projesi olarak React Native (Expo), Node.js ve Python (Flask/FastAPI) kullanılarak geliştirdiğim uçtan uca otonom bir bitki sağlığı sistemidir. YOLO ön filtreleme katmanı sayesinde alakasız görsellerin sistemi yanıltması engellenirken; ResNet34 ile yüksek doğruluklu hastalık sınıflandırması yapılır. Ayrıca RAG tabanlı Llama 3 asistanı ile özelleştirilmiş tarımsal tedavi reçeteleri oluşturulur, bu süreçler akıllı takvim bildirimleriyle desteklenir ve sonuçlar profesyonel PDF raporları olarak dışa aktarılabilir.", type: "Github",
        link: "https://github.com/asmss/bitirme_bitkilerdeHastalikTahminiApp",
        img: "/image/bitirme_img/avokado.jpg",
        images: [
          "/image/bitirme_img/analizpage.jpeg",
          "/image/bitirme_img/anasayfa.jpeg",
          "/image/bitirme_img/chatbotpage.jpeg",
          "/image/bitirme_img/takvim_page.jpeg"
        ],
        tags: ["React Native", "Python", "Node.js", "YOLOv8", "ResNet34", "Llama 3", "MongoDB"]
      },
      {
        title: "e-Ticaret Demo",
        category: "web",
        desc: "React ve JavaScript mimarisiyle geliştirilen bu e-ticaret demosu, modern web standartlarını ve kullanıcı dostu arayüz yaklaşımlarını içermektedir. Projede veri yönetimi için LocalStorage API entegre edilerek, kullanıcı sepetinin ve tercihlerinin tarayıcı bazlı kalıcılığı sağlanmıştır. Dinamik ürün listeleme, sepet güncellemeleri ve tüm cihazlara uyumlu (responsive) tasarımıyla öne çıkan bu çalışma, Netlify üzerinde canlıya alınmıştır.",
        link: "https://eticaretsitesidemo.netlify.app/",
        github: "https://github.com/asmss/eTicaretSitesiDemo",
        type: "Web Sitesi",
        img: "/image/eticaret.png",
        images: [
          "/image/eticaret1.png",
          "/image/eticaret2.png",
          "/image/eticaret3.png",
          "/image/eticaret4.png",
        ],
        tags: ["React", "JavaScript", "LocalStorage", "Netlify", "E-Commerce UI"]
      },
      {
        title: "Mini Katalog Uygulaması",
        category: "mobile",
        desc: "Flutter ve Dart kullanılarak geliştirilen bu katalog uygulamasında, ürün listeleme ve kategori yönetimi üzerine odaklanılmıştır. Projede verilerin uygulama kapansa dahi korunabilmesi için Shared Preferences entegrasyonu yapılmıştır. Bu sayede yerel veri depolama (local storage) ve kalıcı kullanıcı tercihleri yönetimi konularında pratik bir çözüm sunulmuştur.",
        link: "https://github.com/asmss/mini_catalog_app",
        type: "Github",
        img: "/image/katalog.png",
        images: [
          "/image/minikatalog/home.jpeg",
          "/image/minikatalog/home2.jpeg",
          "/image/minikatalog/sepet1.jpeg",
          "/image/minikatalog/sepet2.jpeg",
          "/image/minikatalog/ürün detay.jpeg",
          "/image/minikatalog/ürün detay2.jpeg",
        ],
        tags: ["Flutter", "Dart", "Shared Preferences", "Local Storage", "UI Design"]
      },
      {
        title: "CV Oluşturucu",
        category: "mobile",
        desc: "Bu proje, React Native (Expo) ile geliştirilen mobil bir arayüz üzerinden alınan kullanıcı verilerini, Node.js & Express.js tabanlı bir backend ile işleyerek PDF CV çıktısı üreten bir sistemdir. Backend tamamen Docker ortamında çalışmakta ve Render üzerinde canlıya alınmıştır.",
        link: "https://github.com/asmss/cv_olusturucu-0",
        type: "Github",
        img: "/image/cv_img.jpg",
        images: [
          "/image/cvgen1.jpeg",
          "/image/cvgen2.jpeg",
          "/image/cvgen3.jpeg",
          "/image/cvgen4.jpeg",
        ],
        tags: ["React Native", "Node.js", "Express.js", "Docker", "Expo", "Postman"]
      },
      {
        title: "SnippetKRBLT",
        category: ["mobile", "ai"],
        desc: "Bu uygulamayı geliştirirken, kullanıcıya en iyi mobil deneyimi sunmak için Frontend katmanında React Native ve kolay dağıtım için Expo Go platformunu kullandım. Projenin Backend omurgasını ise yüksek performans ve ölçeklenebilirlik sağlamak amacıyla Node.js ve Express.js oluşturuyor. Tüm kod parçacıkları ve kullanıcı verileri ise güvenilir bir bulut tabanlı çözüm olan MongoDB Atlas üzerinde saklanmaktadır. Ayrıca, uygulamanın ana ayırt edici özelliği olarak, kod parçacıklarını analiz etmek ve yönetimi kolaylaştırmak için LLM (Llama 3) yapay zekasını projemize chatbot olacak şekilde entegre ettim.",
        link: "https://github.com/asmss/SnippetKRBLT",
        type: "Github",
        img: "/image/code-icon-png-0.jpg",
        images: [
          "/image/snippet.jpeg",
          "/image/snippet2.jpeg"
        ],
        tags: ["React Native", "Node.js", "Express.js", "MongoDB Atlas", "Llama 3", "Expo"]
      },
      {
        title: "Vintage Note",
        category: "mobile",
        desc: "Flutter ile geliştirilen, Offline-First mimarisine sahip gelişmiş bir not alma uygulamasıdır. Yerel veri yönetimi için yüksek performanslı Isar NoSQL veritabanı, bulut senkronizasyonu için ise MongoDB Atlas ve Flask (Python) tabanlı bir backend altyapısı kullanılmıştır(render ile yayına alınmıştır). Awesome Notifications ile hatırlatıcı sistemleri, Provider ile state yönetimi ve http.Client ile modüler API entegrasyonu sağlanmıştır. Veri tutarlılığı için local-to-cloud senkronizasyon algoritmaları ve Render uyanma süreleri için optimize edilmiş timeout mekanizmaları içermektedir.",
        link: "https://github.com/asmss/notes_project_0/",
        type: "Github",
        img: "/image/notes.png",
        images: [
          "/image/vintage1.jpeg",
          "/image/vintage2.jpeg"
        ],
        tags: ["Flutter", "Flask", "MongoDB Atlas", "Isar DB", "Provider", "Offline-First", "render"]
      },
      {
        title: "YouTube Video & Music Converter",
        category: "web",
        desc: "Bu projede React ve Node.js kullanarak YouTube videolarını yüksek kaliteli ses ve video formatında dosyalara dönüştüren bir platform geliştirdim. Arka planda dönüşüm süreçlerini yönetmek için BullMQ ve Redis tabanlı bir kuyruk sistemi kullandım. Dockerize edilmiş yapısıyla ölçeklenebilir bir mimariye sahiptir ve Socket.io ile kullanıcıya anlık işlem durumu bildirimi sağlar.",
        link: "https://github.com/asmss/videoConventer",
        type: "Github",
        img: "/image/videoConventer.png",
        tags: ["React", "Node.js", "Redis", "BullMQ", "Docker", "Socket.io"]
      },
      {
        title: "3D İzometrik Oda Tasarımı",
        category: "design",
        desc: "Blender kullanarak tasarladığım bu projede, modern ve minimal bir oturma odası konseptini izometrik bakış açısıyla modelledim. Proje kapsamında mesh modelleme, kumaş simülasyonu (yastıklar için pofuduk yapı), gelişmiş ışıklandırma (Area & Sun Light) ve malzeme (shading/node) tekniklerini uyguladım. Özellikle 3D dünyasındaki derinlik ve ışık-gölge dengesi üzerine odaklandığım bir çalışma oldu.",
        link: "https://github.com/asmss/tnc_blender_project",
        type: "Github",
        img: "/image/AsımKarabulut.png",
        tags: ["Blender", "3D Modeling", "Isometric Design", "Shading", "Cloth Simulation"]
      },
      {
        title: "Kişisel finans takip uygulaması",
        category: "mobile",
        desc: "Bu projemde flutter + firebase kullandım. Bu uygulamanın amacı başlıkta belirttiğim gibi insanların finansal manada yaptığı harcamalar, gelir-gider durumu takibi, canlı döviz verileriyle kendi gelir giderinin hesabı, hatırlatma ve planlama vb. gibi işlemlerin takibini yapmak.",
        link: "https://drive.google.com/file/d/10wudKLoNPqlIok_CjniL7hzennVgTqSI/view?usp=sharing",
        type: "İndir",
        img: "/image/app_icon_512x512_bigger.png",
        images: [
          "/image/kişiselfinans1.jpeg",
          "/image/kişiselfinans2.jpg"
        ],
        tags: ["Flutter", "Firebase", "Finance API"]
      },
      {
        title: "Ruhsal Durum Takibi",
        category: ["mobile", "ai"],
        desc: "Bu projemde flutter + firebase kullandım. Bu uygulamanın amacı başlıkta belirttiğim gibi insanlara psikolojik destek sağlamak, günlük olarak ruhsal durumunun değişimini görmek vb. şeyler.",
        link: "https://drive.google.com/file/d/1A0vFglOjNzFLlFsOzDtoHhd9O-h6gm5C/view?usp=sharing",
        type: "İndir",
        img: "/image/app_icon.png",
        tags: ["Flutter", "Firebase", "Gemini ai API"]
      },
      {
        title: "YesilSepet",
        category: "web",
        desc: "Bu projemde küçük bir e-ticaret sitesinin belli başlı sayfalarıyla küçük bir demosunu yapmayı amaçladım. Projemde session-based authentication (oturum yönetimi) ve MYSQL veri tabanı kullandım. Backend altyapısını node.js + express.js ile geliştirerek, stateful API endpoint'leri tasarladım ayrıca bu api endpointlerini Postman ile test ettim. Proje kullanıcıların; üye olup giriş yapabileceği, ürünleri sepete ekleyebileceği, admin için ürün update işlemlerinin yapılabileceği .vb bir web sitesi.",
        link: "https://github.com/asmss/YesilSepet-0",
        type: "Github",
        img: "/image/resimss.png",
        tags: ["Node.js", "Express", "MySQL", "Postman"]
      },
      {
        title: "KimHaklı",
        category: "web",
        desc: "Bu projemde küçük ve kullanışlı bir mini anket sitesi yapmayı amaçladım. Projemde session-based authentication (oturum yönetimi)ve veri tabanı olarak firebase firestore kullandım. Backend tarafını da node.js + express.js ile geliştirdim. Postmanla testlerini yapıp render ile deploy ettim. Detaylar için sitemi ziyaret edin.",
        link: "https://www.kimhakli.site/",
        type: "Site",
        img: "/image/kimhakli.png",
        tags: ["Node.js", "Firebase", "Render", "Postman", "Html", "Css", "Ejs templating"]
      },
      {
        title: "Neobez",
        category: ["mobile", "ai"],
        desc: "Bu program sayesinde ;programın kendi içindeki real-time mesajlaşma sayfası sayesinde gerçek bir diyetisyenle konuşma fırsatı bulunuyor, hazır yapay zeka API sini entegre ettiğim bir sayfa sayesinde yapay zeka botuyla fikir alışverişi yapılabiliyor ,diyetisyenin kendilerine verebileceği görevleri yapıp ilerleme kontrolü yapılıyor ,yaklaşık 1500 tane yiyecek verisinin olduğu yiyeceklerin kalori,protein vb değerlerinin yazdığı bir sayfa sayesinde araştırma imkanı sunar. Program için flutter frameworkünü ,veritabanı olarak Firebase'in noSQL yapılı Firestore database'ini,auth işlemleri içinde Firebase auth servisini kullandım.",
        link: "https://drive.google.com/file/d/1L54k6Qi4Ks2A1MEanOQPNhJWdQyowcQH/view?usp=drive_link",
        type: "İndir",
        img: "/image/app_png.png",
        tags: ["Flutter", "Firebase", "Gemini ai API"]
      },
      {
        title: "Device Manager",
        category: "mobile",
        desc: "Flutter ile geliştirilmiş olup yazdığım Android Native (java) kodlarını entegre ettiğim bir mobil uygulamadır. Uygulama; cihazın parlaklık, ses, titreşim ve batarya gibi donanımsal özelliklerini MethodChannel aracılığıyla kontrol eder. Riverpood ile state management sağlanmıştır. Github kodlarına ve uygulama arayüzüne ulaşmak için tıklayın.",
        link: "https://github.com/asmss/DeviceManager",
        type: "Github",
        img: "/image/default-project.png",
        tags: ["Flutter", "Android Native", "Java", "MethodChannel", "Riverpod"]
      }
    ],
    certificatesTitle: "Sertifikalar",
    viewCertificate: "Sertifikayı Görüntüle",
    certificates: [    
        {
        title: "Ağ Cihazları ve İlk Yapılandırma",
        issuer: "Cisco Networking Akademi",
        date: "2026",
        img: "/image/Cisco.png",
        link: "/sertifikalar/ciscoCertificate.pdf"
      },
      {
        title: "C# Programlama Dili",
        issuer: "BTK Akademi",
        date: "2026",
        img: "/image/571_0x400.png",
        link: "/sertifikalar/Csharp.pdf"
      },
      {
        title: "Python For Everybody Specialization Program",
        issuer: "University Of Michigan",
        date: "2025",
        img: "/image/michigan.jpeg",
        link: "/sertifikalar/pythonforeverybody.pdf"
      },
      {
        title: "Using Python to Access Web Data",
        issuer: "University Of Michigan",
        date: "2025",
        img: "/image/michigan.jpeg",
        link: "/sertifikalar/usingpython.pdf"
      },
      {
        title: "Getting Started With Git and Github",
        issuer: "IBM",
        date: "2026",
        img: "/image/ibm_logo.jpeg",
        link: "/sertifikalar/gitgithub.pdf"
      },
      {
        title: " Bilgisayar dosya güvenliği ve veri kurtarma",
        issuer: "ODTÜ",
        date: "2025",
        img: "/image/orta_dogu_teknik_universitesi_logo.jpeg",
        link: "/sertifikalar/Bilgisayardaki_Dosyaların_Guvenliği_ve_Veri_Kurtarma-Sertifika_444170.pdf"
      },
    ],

  },
  en: {
    role: "Computer Engineer",

    aboutTitle: "About Me",
    aboutText:
      "I am a graduate of the Department of Computer Engineering at Konya Technical University. I develop scalable and user-friendly solutions using modern technologies across a broad spectrum—ranging from mobile applications to complex backend systems and computer networks.",

    skillsTitle: "Skills",
    projectsTitle: "My Projects",

    navAbout: "About",
    navProjects: "Projects",
    navContact: "Contact",

    contact: "Contact",
    contactTitle: "Get In Touch",

    filterAll: "All",
    filterMobile: "Mobile",
    filterWeb: "Web",
    filterAi: "Artificial Intelligence",
    filterDesign: "Design",

    formName: "Your Name",
    formEmail: "Your Email",
    formMsg: "Your Message",
    formBtn: "Send",
    navCv: "Download CV",


    projects: [
      {
        title: "Plant Disease Detection App (Undergraduate Graduation Project)",
        category: ["mobile", "ai"],
        desc: "Developed as an academic undergraduate graduation project in Computer Engineering at Konya Technical University, this is an end-to-end autonomous plant health system built using React Native (Expo), Node.js, and Python (Flask/FastAPI). It prevents irrelevant images from misleading the system via a YOLO pre-filtering layer, while performing high-accuracy disease classification with ResNet34. Furthermore, it generates customized agricultural treatment prescriptions through an RAG-backed Llama 3 assistant, synchronizes tasks with smart calendar notifications, and exports results into professional PDF reports.", type: "Github",
        link: "https://github.com/asmss/bitirme_bitkilerdeHastalikTahminiApp",
        img: "/image/bitirme_img/avokado.jpg",
        images: [
          "/image/bitirme_img/analizpage.jpeg",
          "/image/bitirme_img/anasayfa.jpeg",
          "/image/bitirme_img/chatbotpage.jpeg",
          "/image/bitirme_img/takvim_page.jpeg"
        ],
        tags: ["React Native", "Python", "Node.js", "YOLOv8", "ResNet34", "Llama 3", "MongoDB"]
      }, {
        title: "e-Commerce Demo",
        category: "web",
        desc: "Developed with React and JavaScript, this e-commerce demo incorporates modern web standards and user-friendly interface approaches. By integrating the LocalStorage API for data management, browser-based persistence of user carts and preferences was achieved. This project, which stands out with its dynamic product listing, cart updates, and responsive design, is deployed live on Netlify.",
        link: "https://eticaretsitesidemo.netlify.app/",
        github: "https://github.com/asmss/eTicaretSitesiDemo",
        type: "Website",
        img: "/image/eticaret.png",
        images: [
          "/image/eticaret1.png",
          "/image/eticaret2.png",
          "/image/eticaret3.png",
          "/image/eticaret4.png",
        ],
        tags: ["React", "JavaScript", "LocalStorage", "Netlify", "E-Commerce UI"]
      },
      {
        title: "Mini Catalog App",
        category: "mobile",
        desc: "This catalog application, developed with Flutter and Dart, focuses on product listing and category management. Shared Preferences integration was implemented to ensure data persistence even when the app is closed. This provides a practical solution for local storage management and persistent user preferences.",
        link: "https://github.com/asmss/mini_catalog_app",
        type: "Github",
        img: "/image/katalog.png",
        images: [
          "/image/minikatalog/home.jpeg",
          "/image/minikatalog/home2.jpeg",
          "/image/minikatalog/sepet1.jpeg",
          "/image/minikatalog/sepet2.jpeg",
          "/image/minikatalog/ürün detay.jpeg",
          "/image/minikatalog/ürün detay2.jpeg",

        ],
        tags: ["Flutter", "Dart", "Shared Preferences", "Local Storage", "UI Design"]
      },
      {
        title: "CV Generator",
        category: "mobile",
        desc:
          "This project is a system that generates PDF CV outputs by processing user data collected from a React Native (Expo) mobile interface using a Node.js and Express.js backend. The backend runs entirely in a Docker environment and is deployed on Render.",
        link: "https://github.com/asmss/cv_olusturucu-0",
        type: "Github",
        img: "/image/cv_img.jpg",
        images: [
          "/image/cvgen1.jpeg",
          "/image/cvgen2.jpeg",
          "/image/cvgen3.jpeg",
          "/image/cvgen4.jpeg",
        ],
        tags: ["React Native", "Node.js", "Express.js", "Docker", "Expo", "Postman"]
      },
      {
        title: "SnippetKRBLT",
        category: ["mobile", "ai"],
        desc:
          "A mobile-focused version of the SnippetKRBLT project, offering the same AI-powered code snippet management features through a React Native interface.",
        link: "https://github.com/asmss/SnippetKRBLT",
        type: "Github",
        img: "/image/code-icon-png-0.jpg",
        images: [
          "/image/snippet.jpeg",
          "/image/snippet2.jpeg"
        ],
        tags: ["React Native", "Node.js", "Express.js", "MongoDB Atlas", "Llama 3", "Expo"]
      },
      {
        title: "Vintage Note",
        category: "mobile",
        desc: "An advanced note-taking application with an Offline-First architecture, built with Flutter. It utilizes high-performance Isar NoSQL for local storage and MongoDB Atlas with a Flask (Python) backend for cloud synchronization (It has been published with a render.). The app features reminder systems via Awesome Notifications, state management with Provider, and modular API integration using http.Client. It includes robust local-to-cloud sync algorithms for data persistence and optimized timeout mechanisms to handle cold starts on Render hosting.",
        link: "https://github.com/asmss/notes_project_0/",
        type: "Github",
        img: "/image/notes.png",
        images: [
          "/image/vintage1.jpeg",
          "/image/vintage2.jpeg"
        ],
        tags: ["Flutter", "Flask", "MongoDB Atlas", "Isar DB", "Provider", "Offline-First", "render"]
      },
      {
        title: "YouTube Video & Music Converter",
        category: "web",
        desc: "Developed a robust platform using React and Node.js for converting YouTube videos into high-quality audio and video files format. The system features a background processing architecture powered by BullMQ and Redis for efficient task queuing. It is fully containerized using Docker and utilizes Socket.io to provide users with real-time conversion progress updates.",
        link: "https://github.com/asmss/videoConventer",
        type: "Github",
        img: "/image/videoConventer.png",
        tags: ["React", "Node.js", "Redis", "BullMQ", "Docker", "Socket.io"]
      },
      {
        title: "3D Isometric Room Design",
        category: "design",
        desc: "In this project designed with Blender, I modeled a modern and minimal living room concept from an isometric perspective. I applied techniques such as mesh modeling, cloth simulation (for the fluffy pillows), advanced lighting (Area & Sun Light), and material (shading/node) systems. This work specifically focuses on depth, light-shadow balance, and composition in the 3D environment.",
        link: "https://github.com/asmss/tnc_blender_project",
        type: "Github",
        img: "/image/AsımKarabulut.png",
        tags: ["Blender", "3D Modeling", "Isometric Design", "Shading", "Cloth Simulation"]
      },
      {
        title: "Personal Finance Tracking Application",
        category: "mobile",
        desc:
          "In this project, I used Flutter and Firebase. The application allows users to track their expenses and income, analyze their financial status, calculate balances with live exchange rates, and manage reminders and planning features.",
        link: "https://drive.google.com/file/d/10wudKLoNPqlIok_CjniL7hzennVgTqSI/view?usp=sharing",
        type: "Download",
        img: "/image/app_icon_512x512_bigger.png",
        images: [
          "/image/kişiselfinans1.jpeg",
          "/image/kişiselfinans2.jpeg"
        ],
        tags: ["Flutter", "Firebase", "Finance API"]
      },

      {
        title: "Mental Health Tracker",
        category: ["mobile", "ai"],
        desc:
          "Developed using Flutter and Firebase. The purpose of this application is to provide psychological support and allow users to track daily changes in their mental state.",
        link: "https://drive.google.com/file/d/1A0vFglOjNzFLlFsOzDtoHhd9O-h6gm5C/view?usp=sharing",
        type: "Download",
        img: "/image/app_icon.png",
        tags: ["Flutter", "Firebase", "Gemini ai API"]
      },
      {
        title: "YesilSepet",
        category: "web",
        desc:
          "In this project, I developed a small demo of an e-commerce website with core pages. I implemented session-based authentication and used MySQL as the database. The backend was built with Node.js and Express.js, and all API endpoints were tested using Postman. Users can register, log in, add products to the cart, and admins can manage product updates.",
        link: "https://github.com/asmss/YesilSepet-0",
        type: "Github",
        img: "/image/resimss.png",
        tags: ["Node.js", "Express.js", "MySQL", "Postman"]
      },
      {
        title: "KimHaklı",
        category: "web",
        desc:
          "A small and practical mini survey application. I implemented session-based authentication and used Firebase Firestore as the database. The backend was developed with Node.js and Express.js, tested with Postman, and deployed using Render.",
        link: "https://www.kimhakli.site/",
        type: "Website",
        img: "/image/kimhakli.png",
        tags: ["Node.js", "Firebase", "Firestore", "Render", "HTML", "CSS", "JavaScript"]
      },
      {
        title: "Neobez",
        category: ["mobile", "ai"],
        desc:
          "This application provides real-time messaging with a professional dietitian, an AI-powered chatbot for consultation, task-based progress tracking, and a food database containing nutritional values for approximately 1,500 food items. The app was built using Flutter, Firebase Firestore, and Firebase Authentication.",
        link: "https://drive.google.com/file/d/1L54k6Qi4Ks2A1MEanOQPNhJWdQyowcQH/view?usp=drive_link",
        type: "Download",
        img: "/image/app_png.png",
        tags: ["Flutter", "Firebase", "Gemini ai API"]
      },
      {
        title: "Device Manager",
        category: "mobile",
        desc:
          "A Flutter-based mobile application that integrates Android Native (Java) code. The app controls hardware features such as brightness, volume, vibration, and battery using MethodChannel. State management is handled with Riverpod.",
        link: "https://github.com/asmss/DeviceManager",
        type: "Github",
        img: "/image/default-project.png",
        tags: ["Flutter", "Android Native", "Java", "MethodChannel", "Riverpod"]
      }
    ],
    certificatesTitle: "Certificates",
    viewCertificate: "View Certificate",
    certificates: [
              {
        title: "Networking Devices and Initial Configuration",
        issuer: "Cisco Networking Academy",
        date: "2026",
        img: "/image/Cisco.png",
        link: "/sertifikalar/ciscoCertificate.pdf"
      },
      {
        title: "C# Programming Language",
        issuer: "BTK Academy",
        date: "2026",
        img: "/image/571_0x400.png",
        link: "/sertifikalar/Csharp.pdf"
      },
      {
        title: "Python For Everybody Specialization Program",
        issuer: "University Of Michigan",
        date: "2025",
        img: "/image/michigan.jpeg",
        link: "/sertifikalar/pythonforeverybody.pdf"
      },
      {
        title: "Using Python to Access Web Data",
        issuer: "University Of Michigan",
        date: "2025",
        img: "/image/michigan.jpeg",
        link: "/sertifikalar/usingpython.pdf"
      },
      {
        title: "Getting Started With Git and Github",
        issuer: "IBM",
        date: "2026",
        img: "/image/ibm_logo.jpeg",
        link: "/sertifikalar/gitgithub.pdf"
      },
      {
        title: " Computer file security and data recovery",
        issuer: "ODTÜ",
        date: "2025",
        img: "/image/orta_dogu_teknik_universitesi_logo.jpeg",
        link: "/sertifikalar/Bilgisayardaki_Dosyaların_Guvenliği_ve_Veri_Kurtarma-Sertifika_444170.pdf"
      },
    ],

  }
};
